import { OdataManager } from '@/api/odata/odata-manager';
import { DrawingPackageStatus } from '@/api/model/interfaces';

export default class DrawingPackageStatusOdata extends OdataManager<DrawingPackageStatus> {}
